import { IconProp } from '@fortawesome/fontawesome-svg-core'
import {
    faDiscord,
    faFacebookF,
    faInstagram,
    faLinkedin,
    faReddit,
    faTiktok,
    faTwitch,
    faTwitter,
    faVk,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { faComments } from '@fortawesome/free-regular-svg-icons'
// import { faFacebookF, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { SubStatusKey } from './Types'

// logos used in footer

import ubisoft_store_logo from './images/footer/ubisoft_logo_store.png'
import ubisoft_white_logo from './images/footer/ubisoft-white.png'
import ubisoft_club_logo from './images/footer/uplay_83657.png'
import ubisoft_blog_logo from './images/footer/ubisoft-ubiblog-footer-logo.png'
import ps4_logo from './images/footer/ps4_logo_101541.png'
import xone_logo from './images/footer/xboxone_horizontal_c-wht_rgb_98854.png'
import pc_dvd_logo from './images/footer/pc-dvd_83673.png'
import esrb_rating_teen from './images/footer/footer-esrb-rating-teen.jpg'
import esrb_game_rating_m_border from './images/footer/esrb-game_rating-m-border.jpg'
import esrb_privacy_cert from './images/footer/privacy-certified-globe-color-ubiosoft_110500.jpg'
import esrb_rating_rp from './images/footer/esrb-rating-rp.jpg'
import esrb_rating_teen2 from './images/footer/esrb_rating_teen2.jpg'
import esrb_rating_teen17_update from './images/footer/esrb-update.png'
import esrb_rating_extended from './images/footer/xdef-esrb-rating-extended.png'
import pegi7_logo from './images/footer/pegi7-white.jpg'
import pegi12_logo from './images/footer/pegi-12_83658.png'
import pegi16_logo from './images/footer/Pegi-16-provisional.png'
import pegi16_2_logo from './images/footer/pegi16-white.png'
import pegi18_logo from './images/footer/pegi18-white.jpg'
import nvidia_logo from './images/footer/logo_nvidia_geforce_107645.png'
import usk6_logo from './images/footer/usk6.png'
import usk12_logo from './images/footer/usk12.png'
import usk16_logo from './images/footer/usk16.png'
import usk18_logo from './images/footer/usk18.png'
import rars12_logo from './images/footer/rars12.png'
import rars18_logo from './images/footer/rars18.png'
import _12_trails_logo from './images/footer/12-trails.jpg'
import acbG_logo from './images/footer/acbG.png'
import acbM_logo from './images/footer/acbM.png'
import acbCTC_logo from './images/footer/acbCTC.png'
import acbPG_logo from './images/footer/acbPG.png'
import acbR18_logo from './images/footer/acbR18.png'
import gsrrG_logo from './images/footer/gsrrG.jpg'
import gsrrPG12_logo from './images/footer/gsrrPG12.jpg'
import gsrrPG15_logo from './images/footer/gsrrPG15.jpg'
import gsrrPG18_logo from './images/footer/gsrrPG18.jpg'
import gsrrR_logo from './images/footer/gsrrR.jpg'
import gracAll_logo from './images/footer/gracAll.png'
import grac12_logo from './images/footer/grac12.png'
import grac18_logo from './images/footer/grac18.png'
import grac15_logo from './images/footer/grac15.png'
import gracRP_logo from './images/footer/gracRP.png'
import fc6_br_rating from './images/footer/BR_Rating-DJCTQ-16.png'
import ceroa_rating from './images/footer/ceroA.png'
import ceroc_rating from './images/footer/ceroC.png'
import ceroz_rating from './images/footer/ceroZ.png'
import cerod_rating from './images/footer/ceroD.png'
import cerorp_rating from './images/footer/ceroRP.png'
import r6e_esrb from './images/footer/esrb-r6e.jpg'
import br_rating_16 from './images/footer/r6e_br_rating_16.jpg'
import acbMA15 from './images/footer/acbMA15.png'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'


import appstore_de_badge_web from './images/store-logos/appstore_de_badge_web.png'
import appstore_es_badge_web from './images/store-logos/appstore_es_badge_web.png'
import appstore_fr_badge_web from './images/store-logos/appstore_fr_badge_web.png'
import appstore_it_badge_web from './images/store-logos/appstore_it_badge_web.png'
import appstore_jp_badge_web from './images/store-logos/appstore_jp_badge_web.png'
import appstore_kr_badge_web from './images/store-logos/appstore_kr_badge_web.png'
import appstore_pl_badge_web from './images/store-logos/appstore_pl_badge_web.png'
import appstore_ptbr_badge_web from './images/store-logos/appstore_ptbr_badge_web.png'
import appstore_en_badge_web from './images/store-logos/appstore_us_badge_web.png'
import appstore_zhtw_badge_web from './images/store-logos/appstore_zhtw_badge_web.png'

import googleplay_de_badge_web from './images/store-logos/googleplay_de_badge_web.png'
import googleplay_es_badge_web from './images/store-logos/googleplay_es_badge_web.png'
import googleplay_fr_badge_web from './images/store-logos/googleplay_fr_badge_web.png'
import googleplay_it_badge_web from './images/store-logos/googleplay_it_badge_web.png'
import googleplay_jp_badge_web from './images/store-logos/googleplay_jp_badge_web.png'
import googleplay_ko_badge_web from './images/store-logos/googleplay_ko_badge_web.png'
import googleplay_pl_badge_web from './images/store-logos/googleplay_pl_badge_web.png'
import googleplay_ptbr_badge_web from './images/store-logos/googleplay_pt-br_badge_web.png'
import googleplay_en_badge_web from './images/store-logos/googleplay_us_badge_web.png'
import googleplay_zhtw_badge_web from './images/store-logos/googleplay_zh-tw_badge_web.png'


const ubisoft_white_img = { img: ubisoft_white_logo, alt: 'Ubisoft Logo', link: 'https://www.ubisoft.com/' }
const ubisoft_store_img = { img: ubisoft_store_logo, alt: 'Ubisoft Store Logo', link: 'https://store.ubi.com/' }
const ubisoft_club_img = { img: ubisoft_club_logo, alt: 'Ubisoft Club', link: 'https://club.ubisoft.com/' }
const ubisoft_blog_img = { img: ubisoft_blog_logo, alt: 'Ubisoft Blog', link: 'https://blog.ubisoft.com/' }
const ps4_logo_img = { img: ps4_logo, alt: 'Ubisoft Blog', link: 'https://www.playstation.com/' }
const xone_logo_img = { img: xone_logo, alt: 'Ubisoft Blog', link: 'https://www.xbox.com/' }
const pc_dvd_logo_img = (link: string) => ({ img: pc_dvd_logo, alt: 'Ubisoft Store', link: link })
const esrb_rating_teen_img = {
    img: esrb_rating_teen,
    alt: 'ESRB Rating',
    link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
}
const esrb_ratingm_img = {
    img: esrb_game_rating_m_border,
    alt: 'ESRB Rating',
    link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
}
const esrb_privacy_cert_img = {
    img: esrb_privacy_cert,
    alt: 'ESRB Privacy Certified',
    link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
}
const esrb_rating_rp_img = { img: esrb_rating_rp, alt: 'ESRB Rating', link: 'https://www.esrb.org/ratings-guide/' }
const esrb_rating_teen2_img = {
    img: esrb_rating_teen2,
    alt: 'ESRB Rating',
    link: 'https://www.esrb.org/ratings-guide/',
}
const esrb_rating_teen17_update_img = {
    img: esrb_rating_teen17_update,
    alt: 'ESRB Rating',
    link: 'https://www.esrb.org/ratings-guide/',
}
const esrb_rating_extended_img = {
    img: esrb_rating_extended,
    alt: 'ESRB Rating',
    link: 'https://www.esrb.org/ratings-guide/',
}
const pegi7_img = { img: pegi7_logo, alt: 'PEGI 7', link: 'https://pegi.info' }
const pegi12_img = { img: pegi12_logo, alt: 'PEGI 12', link: 'https://pegi.info' }
const pegi16_img = { img: pegi16_logo, alt: 'PEGI 16', link: 'https://pegi.info' }
const pegi16_2_img = { img: pegi16_2_logo, alt: 'PEGI 16', link: 'https://pegi.info' }
const pegi18_img = { img: pegi18_logo, alt: 'PEGI 18', link: 'https://pegi.info' }
const nvidia_logo_img = { img: nvidia_logo, alt: 'NVIDIA GeForce', link: 'https://www.geforce.com/' }
const usk6_logo_img = { img: usk6_logo, alt: 'USK De', link: 'http://www.usk.de' }
const usk12_logo_img = { img: usk12_logo, alt: 'USK De', link: 'http://www.usk.de' }
const usk16_logo_img = { img: usk16_logo, alt: 'USK De', link: 'http://www.usk.de' }
const usk18_logo_img = { img: usk18_logo, alt: 'USK De', link: 'http://www.usk.de' }
const rars12_logo_img = { img: rars12_logo, alt: 'Rars 12', link: '' }
const rars18_logo_img = { img: rars18_logo, alt: 'Rars 18', link: '' }
const _12_trails_img = {
    img: _12_trails_logo,
    alt: 'Guide',
    link: 'https://www.justica.gov.br/seus-direitos/classificacao/guia-pratico',
}
const acbG_logo_img = { img: acbG_logo, alt: 'G', link: 'https://www.classification.gov.au/' }
const acbM_logo_img = { img: acbM_logo, alt: 'M', link: 'https://www.classification.gov.au/' }
const acbCTC_logo_img = { img: acbCTC_logo, alt: 'CTC', link: 'https://www.classification.gov.au/' }
const acbPG_logo_img = { img: acbPG_logo, alt: 'PG', link: 'https://www.classification.gov.au/' }
const acbR18_logo_img = { img: acbR18_logo, alt: '18', link: 'https://www.classification.gov.au/' }
const gsrrG_logo_img = { img: gsrrG_logo, alt: 'gamerating G', link: 'http://www.gamerating.org.tw/' }
const gsrrPG12_logo_img = { img: gsrrPG12_logo, alt: 'gamerating PG12', link: 'http://www.gamerating.org.tw/' }
const gsrrPG15_logo_img = { img: gsrrPG15_logo, alt: 'gamerating PG15', link: 'http://www.gamerating.org.tw/' }
const gsrrPG18_logo_img = { img: gsrrPG18_logo, alt: 'gamerating PG18', link: 'http://www.gamerating.org.tw/' }
const gsrrR_logo_img = { img: gsrrR_logo, alt: 'gamerating R', link: 'http://www.gamerating.org.tw/' }
const gracAll_logo_img = { img: gracAll_logo, alt: 'grac all', link: 'http://www.grac.or.kr/' }
const grac12_logo_img = { img: grac12_logo, alt: 'grac 12', link: 'http://www.grac.or.kr/' }
const grac15_logo_img = { img: grac15_logo, alt: 'grac 15', link: 'http://www.grac.or.kr/' }
const grac18_logo_img = { img: grac18_logo, alt: 'grac 12', link: 'http://www.grac.or.kr/' }
const gracRP_logo_img = { img: gracRP_logo, alt: 'grac RP', link: 'http://www.grac.or.kr/' }
const fc6_br_rating_img = {
    img: fc6_br_rating,
    alt: 'classificacao',
    link: 'https://www.justica.gov.br/seus-direitos/classificacao',
}
const ceroa_img = { img: ceroa_rating, alt: 'cero a', link: 'http://www.cero.gr.jp/' }
const ceroc_img = { img: ceroc_rating, alt: 'cero c', link: 'http://www.cero.gr.jp/' }
const ceroz_img = { img: ceroz_rating, alt: 'cero z', link: 'http://www.cero.gr.jp/' }
const cerod_img = { img: cerod_rating, alt: 'cero d', link: 'http://www.cero.gr.jp/' }
const cerorp_img = { img: cerorp_rating, alt: 'cero rp', link: 'http://www.cero.gr.jp/' }
const r6e_esrb_img = { img: r6e_esrb, alt: 'esrb m', link: 'http://www.esrb.org/ratings/ratings_guide.jsp' }
const r6e_br_rating_16_img = {
    img: br_rating_16,
    alt: 'esrb m',
    link: 'https://www.justica.gov.br/seus-direitos/classificacao',
}
const skb_br_rating_16_img = { img: br_rating_16, alt: 'esrb m', link: 'http://culturadigital.br/classind/' }

const acbMA15_img = { img: acbMA15, alt: 'acbMA15', link: 'http://www.classification.gov.au' }

export interface SP_FooterImg {
    img: string,
    alt: string,
    link: string,
    cssClass?: string
}

export interface SP_FooterSocial {
    icon: IconProp,
    title: string,
    link: string,
    text?: string,
    cssClass?: string
}

export interface SP_FooterLegalLink {
    text: string,
    link: string,
    cssClass?: string
}

export interface SP_FooterData {
    footerCopyTxt: Record<string, string>,
    showLogo?: boolean,
    footerImages: Record<string, SP_FooterImg[][]>
    footerSocial: Record<string, SP_FooterSocial[]>
    footerLegalLinks: Record<string, SP_FooterLegalLink[]>
}

export interface SP_Game {
    name: string,
    // add logo here as well
    marketingSiteSpaceId: string,
    marketingSiteAppId: string,
    appIds: string[],
    subStatuses: SubStatusKey[],
    twitter: Record<string, string>, // can exist in footerSocial
    helpLinks: SP_FooterLegalLink[],
    supportedLocales: string[],
    footer: Record<string, SP_FooterData>
}

type StoreBadgeMap = {
    google: string;
    apple: string;
};

type LocaleBadgeMap = {
    [locale: string]: StoreBadgeMap;
};



export const appStoreLocales: LocaleBadgeMap = {
    'fr-FR': {
        'google': googleplay_fr_badge_web,
        'apple': appstore_fr_badge_web
    },
    'de-DE': {
        'google': googleplay_de_badge_web,
        'apple': appstore_de_badge_web
    },
    'it-IT': {
        'google': googleplay_it_badge_web,
        'apple': appstore_it_badge_web
    },
    'nl-NL': {
        'google': googleplay_en_badge_web,
        'apple': appstore_en_badge_web
    },
    'pl-PL': {
        'google': googleplay_pl_badge_web,
        'apple': appstore_pl_badge_web
    },
    'ru-RU': {
        'google': '',
        'apple': ''
    },
    'es-ES': {
        'google': googleplay_es_badge_web,
        'apple': appstore_es_badge_web
    },
    'en-US': {
        'google': googleplay_en_badge_web,
        'apple': appstore_en_badge_web
    },
    'en-CA': {
        'google': googleplay_en_badge_web,
        'apple': appstore_en_badge_web
    },
    'en-GB': {
        'google': googleplay_en_badge_web,
        'apple': appstore_en_badge_web
    },
    'fr-CA': {
        'google': googleplay_fr_badge_web,
        'apple': appstore_fr_badge_web
    },
    'es-MX': {
        'google': googleplay_es_badge_web,
        'apple': appstore_es_badge_web
    },
    'pt-BR': {
        'google': googleplay_ptbr_badge_web,
        'apple': appstore_ptbr_badge_web
    },
    'en-AU': {
        'google': googleplay_en_badge_web,
        'apple': appstore_en_badge_web
    },
    'ko-KR': {
        'google': googleplay_ko_badge_web,
        'apple': appstore_kr_badge_web
    },
    'ja-JP': {
        'google': googleplay_jp_badge_web,
        'apple': appstore_jp_badge_web
    },
    'zh-CN': {
        'google': '',
        'apple': ''
    },
    'zh-TW': {
        'google': googleplay_zhtw_badge_web,
        'apple': appstore_zhtw_badge_web
    }
}


const statusPageData: Record<string, SP_Game> = {
    'steep': {
        name: 'Steep',
        marketingSiteSpaceId: 'da1faa7b-cb98-4dcc-ad49-4118d3f87805', // used in headers
        marketingSiteAppId: 'a60ef5e2-1369-43ad-b906-8f8f6e739971',
        appIds: [
            'b65780e8-0875-4685-995a-6e952cc605a8', // PC
            '0bc3cfb0-15a1-4340-915a-b7a76fb2d3e3', // PS4
            '2b55254c-cb0c-4fd8-ab3e-aa684057240a', // XONE
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
            SubStatusKey.Leaderboard,
        ],
        twitter: { 'default': 'Steep_Game' },
        helpLinks: [{ text: 'Customer Support', link: 'https://support.ubisoft.com/Games/5018' }],
        footer: {
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. The Steep logo, Ubisoft, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries.',
                    'pt-BR': '© 2017 Ubisoft Entertainment. All Rights Reserved. Uplay, the Uplay logo, Ubi.com, Ubisoft, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Computer Entertainment Inc. Software platform logo (TM and ©) EMA 2006.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/2017-ubisoft-logo-166x69_white_transp_291885.png',
                                alt: '2017-ubisoft-logo-166x69_white_transp',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/ubisoft_logo_store_white_footer_140px_306899.png',
                                alt: 'Ubisoft Store (White Text - Transparent BG - 140px height)',
                                link: 'http://store.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/ubisoft-ubiblog-footer-logo%28new%29_296006.png',
                                alt: 'Ubi-Blog Footer Logo(New) - Marketing Sites',
                                link: 'https://blog.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/uplay_logo_127461.png',
                                alt: 'ubisoft_club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/ubisoft-uplay-footer-logo-clear_336415.png',
                                alt: 'ubisoft-uplay-footer-logo-clear',
                                link: 'https://uplay.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/privacy-certified-globe-color-ubiosoft_110500.jpg',
                                alt: 'privacy_certified_globe_color',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.jsp',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-us/common/steep-footer-esrb-rating_268370.png',
                                alt: '[Steep] ESRB Rating - T',
                                link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
                            },
                        ],
                    ],
                    'pt-BR': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/pt-br/common/2017-ubisoft-logo-166x69_white_transp_291885.png',
                                alt: '2017-ubisoft-logo-166x69_white_transp',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/pt-br/common/ubisoft_logo_store_white_footer_140px_306899.png',
                                alt: 'Ubisoft Store (White Text - Transparent BG - 140px height)',
                                link: 'http://store.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/pt-br/common/ubisoft-uplay-footer-logo-clear_336415.png',
                                alt: 'ubisoft-uplay-footer-logo-clear',
                                link: 'https://uplay.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/pt-br/common/64px-djctq-12_281450.png',
                                alt: 'PT-BR Rating 12',
                                link: 'http://portal.mj.gov.br/ClassificacaoIndicativa/jsps/ConsultarJogoForm.do',
                            },
                        ],
                    ],
                },
                footerSocial: { 'default': [] },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/termsofuse', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        {
                            link: 'https://legal.ubi.com/InterestBasedAdvertising/en-US?cache=22828524de97e0687d728e89b46a300c',
                            text: 'INTEREST BASED ADVERTISING',
                        },
                        {
                            link: 'https://forums.ubi.com/showthread.php/1516763-Code-of-Conduct',
                            text: 'CODE OF CONDUCT',
                        },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'DO NOT SELL MY PERSONAL INFORMATION' },
                    ],
                    'en-CA': [
                        { link: 'https://legal.ubi.com/termsofuse', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        {
                            link: 'https://legal.ubi.com/InterestBasedAdvertising/en-CA?cache=5c93a4aa1054932159f40945975a2c58',
                            text: 'INTEREST BASED ADVERTISING',
                        },
                        {
                            link: 'https://forums.ubi.com/showthread.php/1516763-Code-of-Conduct',
                            text: 'CODE OF CONDUCT',
                        },
                    ],
                    'fr-CA': [
                        { link: 'https://legal.ubi.com/termsofuse', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        {
                            link: 'https://legal.ubi.com/InterestBasedAdvertising/fr-CA?cache=8312274a3d7de795dc98b0717621571f',
                            text: 'PUBLICITÉ CIBLÉE',
                        },
                        {
                            link: 'https://forums.ubi.com/showthread.php/1516763-Code-of-Conduct',
                            text: 'CODE OF CONDUCT',
                        },
                    ],
                    'pt-BR': [
                        { link: 'https://legal.ubi.com/termsofuse', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        {
                            link: 'https://forums.ubi.com/showthread.php/1516763-Code-of-Conduct',
                            text: 'CÓDIGO DE CONDUTA',
                        },
                    ],
                },
            },
            'emea': {
                footerCopyTxt: {
                    'default': '© 2018 Ubisoft Entertainment. All Rights Reserved. Ubisoft and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries. Used under license from ESPN Enterprises, Inc. X Games is a trademark of ESPN, Inc.',
                    'de-DE': 'Steep TM & © 2017 Ubisoft Entertainment. All Rights Reserved. TM IOC/POCOG2018/USOC 36USC220506. © 2017 IOC. All Rights Reserved.',
                    'it-IT': 'Steep TM & © 2017 Ubisoft Entertainment. All Rights Reserved. TM IOC/POCOG2018/USOC 36USC220506. © 2017 IOC. All Rights Reserved.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-gb/common/uplay_logo_127461.png',
                                alt: 'Ubisoft_Club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-gb/common/ubisoft-white_emea_81038.png',
                                alt: 'Ubisoft (White Text - Transparent BG - 100px height)',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-gb/common/ubisoft-uplay-footer-logo-clear_336415.png',
                                alt: 'ubisoft-uplay-footer-logo-clear',
                                link: 'https://uplay.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-gb/common/pegi-12_83658.png',
                                alt: 'PEGI 12 (Transparent BG - 100px height)',
                                link: 'http://www.pegi.info/',
                            },
                        ],
                    ],
                    'de-DE': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/de-de/common/uplay_logo_127461.png',
                                alt: 'Ubisoft_Club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/de-de/common/ubisoft_303678.png',
                                alt: 'Developped by Ubisoft',
                                link: 'https://www.ubisoft.com/',
                            },
                        ],
                    ],
                    'it-IT': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/it-it/common/uplay_logo_127461.png',
                                alt: 'Ubisoft_Club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/it-it/common/ubisoft_303678.png',
                                alt: 'Developped by Ubisoft',
                                link: 'https://www.ubisoft.com/',
                            },
                        ],
                    ],
                    'en-AU': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-au/common/uplay_logo_127461.png',
                                alt: 'Ubisoft_Club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-au/common/ubisoft-white_emea_81038.png',
                                alt: 'Ubisoft (White Text - Transparent BG - 100px height)',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-au/common/ubisoft-uplay-footer-logo-clear_336415.png',
                                alt: 'ubisoft-uplay-footer-logo-clear',
                                link: 'https://uplay.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/en-au/common/pg%20ms_online%20interactivity_275612.png',
                                alt: 'PG MS_online interactivity',
                                link: 'http://www.classification.gov.au',
                            },
                        ],
                    ],
                    'ru-RU': [
                        [
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/ru-ru/common/uplay_logo_127461.png',
                                alt: 'Ubisoft_Club_logo_white_trans',
                                link: 'https://club.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/ru-ru/common/ubisoft-white_emea_81038.png',
                                alt: 'Ubisoft (White Text - Transparent BG - 100px height)',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/ru-ru/common/ubisoft-uplay-footer-logo-clear_336415.png',
                                alt: 'ubisoft-uplay-footer-logo-clear',
                                link: 'https://uplay.ubi.com/',
                            },
                            {
                                img: 'https://ubistatic19-a.akamaihd.net/resource/ru-ru/common/pegi-12_ru_230711.png',
                                alt: 'PEGI 12 RU (Transparent BG - 100px height)',
                                link: '#',
                            },
                        ],
                    ],
                },
                footerSocial: { 'default': [] },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFORMATION' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                    ],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR'],
    },
    'wdl': {
        name: 'Wdl',
        marketingSiteSpaceId: 'b427e9e6-3986-4be1-9a73-17fb399520f6',
        marketingSiteAppId: '4df0acff-db55-457e-b4e3-5f80c84e6193',
        appIds: [
            'ade80bc2-0462-42bc-837a-851386dc5a9e', // PC
            //"fab10015-30a7-4cdf-97a1-34eace436465", // Stadia
            '7765de0b-2ef1-4cff-88b3-bb63b1a039cf', // PS4
            //"d2223541-dfb1-4d3a-9355-94bf69261a1c", // PS5
            'e3ebc0ef-19af-4704-8f6c-254d19129a02', // XONE
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
            SubStatusKey.Leaderboard,
        ],
        twitter: {
            'default': 'watchdogsgame',
            'en-GB': 'WatchDogs_UK',
            'fr-FR': 'Watch_DogsFR',
            'de-DE': 'WatchDogs_DE',
        },
        helpLinks: [{ text: 'Customer Support', link: 'https://support.ubisoft.com/Games/4569' }],
        footer: {
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2019 Ubisoft Entertainment. All Rights Reserved. Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Computer Entertainment Inc. Software platform logo (TM and ©) EMA 2006.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/d2f9af89354d87f10980979ef375b4e0/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6L6403wmxRZHrpzj5Fliis/f56695faed39c22e49d64c5ebdf466ee/wdl-footer-brand_logo-white.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                alt: 'brandFooter__rating__button__esrb-privacy-footer',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/563Di6tDdNb5lZY88R2e1E/7ab0f6401dcca98b1a20f24911451154/wdl-esrb-rating-descriptors.jpg',
                                alt: 'brandFooter__rating__button__wdl-esrb-rating',
                                link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
                            },
                        ],
                    ],
                    'es-MX': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/d2f9af89354d87f10980979ef375b4e0/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6L6403wmxRZHrpzj5Fliis/18cacb8d80538f0c9559361b7f89f2d2/wdl-footer-brand_logo-white.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                alt: 'brandFooter__rating__button__esrb-privacy-footer',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },
                        ],
                    ],
                    'pt-BR': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/d2f9af89354d87f10980979ef375b4e0/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/6L6403wmxRZHrpzj5Fliis/94b54030bc51414aa05544fee8492671/wdl-footer-brand_logo-white.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                        ],
                    ],
                },
                footerSocial: { 'default': [] },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'UBISOFT TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy/', text: 'DO NOT SELL MY PERSONAL INFORMATION' },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
            'emea': {
                footerCopyTxt: {
                    'default': '© 2019 Ubisoft Entertainment. All Rights Reserved. Watch Dogs, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. The “PS” Family logo and “Playstation” are registered trademark. “PS4” is a trademark of Sony Computer Entertainment Inc. Features and technical capabilities, including 4K and HDR, vary by console. Stadia, the S logo, and related marks and logos are trademarks of Google LLC.',
                    'zh-CN': '©2006-2019 Ubisoft Entertainment. All Rights Reserved. Ubisoft, ubi.com, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/2c80d2bdc0ce5229769ab1197e39e132/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/b1f8cd5af8727f9219c49c6ce89b378f/PEGI-PROV_86x102.png',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.pegi.info/',
                            },
                        ],
                    ],
                    'de-DE': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/ee2fe60c01700dd8814d139145f39cba/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/23a100496213326ca802d66212426c37/USK-PROV_100x102.png',
                                alt: 'brandFooter__rating__button',
                                link: 'https://usk.de/',
                            },
                        ],
                    ],
                    'ru-RU': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/8b295482899d86706b4e9fb19784e111/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/22a32d8bc25618ee7a8d1f3655e7ee06/RU18_102x102.png',
                                alt: 'brandFooter__rating__button',
                                link: '',
                            },
                        ],
                    ],
                    'en-AU': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/2b88d78911fa184d81c11342679a1137/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/f806c91e3cecd3339e6a9add52279f53/OFLC_Check-The-Classification_204x102.png',
                                alt: 'brandFooter__rating__button__esrb-privacy-footer',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },
                        ],
                    ],
                    'ja-JP': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/d55ab9a121a76917c369dc8056df2fe7/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/1851c794864273de15977637a74ab312/CERO_Pending_83x102.jpg',
                                alt: 'brandFooter__rating__button__esrb-privacy-footer',
                                link: 'https://www.cero.gr.jp/',
                            },
                        ],
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5k5pw562vA3FN0VjhPbRJl/d55ab9a121a76917c369dc8056df2fe7/WDL_Logo_white_final.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4PHG9jwzZ86FB1SvKpGU3O/a311012ecf29014ee33b04b1423b611e/18__resize.png',
                                alt: 'brandFooter__rating__button__esrb-privacy-footer',
                                link: 'http://www.gamerating.org.tw/',
                            }],
                    ],
                },
                footerSocial: { 'default': [] },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'pl-PL',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'acv': {
        name: 'Assassin\'s Creed Valhalla',
        marketingSiteSpaceId: 'e4866fa9-de69-4fee-a0d4-89b912e7d062', // used in headers
        marketingSiteAppId: '0de48442-60b9-4b48-8a7d-c8221d6acf67',
        appIds: [
            '9da14e51-9433-421b-a396-2ac916649564', // PC
            '45ccf56d-8f88-46ff-a35e-a2c3ff92aaac', // STADIA
            '2dee0217-d33f-4ffc-99b5-d2947990277d', // PS4
            'b16c3382-0d5e-4cdc-8f71-a3599fc54264', // PS5
            '17bdcbb7-dcba-4f89-b3b3-a277e8d1c35e', // XBOX One
            '02d94411-c6e5-4f4b-b25a-a0b49f3707db',  // XBOX Series X|S
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
        ],
        twitter: { 'default': 'assassinscreed' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://support.ubisoft.com/games/4720' },
            { text: 'Forums', link: 'https://discussions.ubisoft.com/category/542/assassin-s-creed-valhalla' },
            { text: 'Gameplan', link: 'https://www.assassinscreed.com/gameplan' },
        ],
        footer: {
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. The Steep logo, Ubisoft, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/d2f9af89354d87f10980979ef375b4e0/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/39794455a7e6f61032d0e274964a58dc/logo.png',
                                alt: 'brandFooter__brand',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2Q0HdAOwv32T94O7BIPDVw/882846c2ea548b1192c985663bd293c6/ACV_ESRB_small.jpg',
                                alt: 'ESRB Rating - T',
                                link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
                            },
                        ],
                    ],
                    'pt-BR': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/d2f9af89354d87f10980979ef375b4e0/footer_logo.png',
                                alt: 'corporatePanel__logo',
                                link: 'https://www.ubisoft.com/',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/7ac4dbe3350b365d92bbb104ac08ef7e/logo.png',
                                alt: 'brandFooter__brand',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7gWpX8SPkp6AMmZY30gO3D/82e94d334a21fd54ae6119f5072e4462/16.jpg',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },

                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreedUS' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCBMvc6jvuTxH6TNo9ThpYjg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassinscreed_us/' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'DO NOT SELL MY PERSONAL INFORMATION' },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
            'emea': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. Assassin\'s Creed, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                    'zh-CN': '©2006-2020 Ubisoft Entertainment. All Rights Reserved. Ubisoft, ubi.com, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/d30078b832bb45867ad7eb32105da1f6/kingdom-logo.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/1b0135c00d06ead9645c0173a76ee593/GRB_PEGI_rating__3_.png',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.pegi.info/',
                            },
                        ],
                    ],
                    'en-AU': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/626fd27661c3bb894c6634866098f444/kingdom-logo.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/f68a00aefe2da08504d2b393a6d3335b/AgeRating_GRBreakpoint_ACB_Multiplatform_Marking_AUSTRALIA.png',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.pegi.info/',
                            },
                        ],
                    ],
                    'ko-KR': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/efab917e02da1241fe7ebda3ac6c15e9/kingdom-logo.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/6a3738fae851f198a25f18970aaadba7/GRB_KR_rating.png',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.grac.or.kr',
                            },
                        ],
                    ],
                    'ja-JP': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/e4e3eb253d399004c5a98cc34bc63834/ACV-logo-jap__1_.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/85d3a0ec94fc4c6d324c31d831f03b44/CEROZ_website.png',
                                alt: 'brandFooter__rating__button',
                                link: 'https://www.cero.gr.jp/',
                            },
                        ],
                    ],
                    'ru-RU': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/e36782162037174175dab369965117d7/ACV-logo-rus__1_.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/bd84547581afb19b48f9cad490609782/RU18_102x102.png',
                                alt: 'brandFooter__rating__button',
                                link: 'https://www.ubisoft.com/ru-ru/game/assassins-creed/valhalla/',
                            },
                        ],
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5RMQ9vwghls0An4wzhKtz7/3c388f184ed770579bd7648818583ffd/footer_logo.png',
                                alt: '',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5m0vdKO18CoSw0qOkhGyi3/067def539514bf4617fbd02f92f04e5c/ACV-logo-tch__1_.png',
                                alt: 'brandFooter__brand__logo',
                                link: '',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/4HSe1SCsVgWeqimkccXG2b/18dcbae1b8ace7169bff030e94baea33/18__resize.png',
                                alt: 'brandFooter__rating__button',
                                link: 'http://www.gamerating.org.tw/',
                            },
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreed.uk/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PL8za59GW8txR2fII14jAi5eUAENOLLAAM',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'de-DE': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreedde/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PL-gQKwNkaWcLxFd2p9gwGI_LsVEYtWSNn',
                        },
                        {
                            icon: faInstagram,
                            title: 'Instagram',
                            link: 'https://www.instagram.com/assassinscreed_gsa/',
                        },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'es-ES': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/Assassinsspain/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreedspain/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLvj2gJX06ftPAUs1fePSh5oKB3m0WV80V',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassinscreedes/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'fr-FR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/AssassinsFR/' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/assassinscreed.france/',
                        },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLAjBo8yZUnKpiehtAV9dCuCx92_RThU6F',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassinscreedfr/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'it-IT': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/Assassinsita/' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/assassinscreeditalia/',
                        },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLCoW9yn2KZye_Xqd4bjLQmy_us075E0Ta',
                        },
                        {
                            icon: faInstagram,
                            title: 'Instagram',
                            link: 'https://www.instagram.com/assassinscreedgame_it/',
                        },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'nl-NL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/assassinscreednetherlands/',
                        },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLY0uKVAB6iD_dNLmub_k-cn7Z7uwtHQJp',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'pl-PL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/assassinscreedpoland/',
                        },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLj6-3JOkBqCDq9t0S79R5yBuulM-EZdYY',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'ru-RU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UbisoftRussia' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreed/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLoe4C0wU-T7w6-GH9I5dL3grtpyjLR6FC',
                        },
                        {
                            icon: faInstagram,
                            title: 'Instagram',
                            link: 'https://www.instagram.com/assassinscreed_russia',
                        },
                        { icon: faVk, title: 'Vk', link: 'https://vk.com/assassinscreed' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'ko-KR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreed/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPsiArkYTl6YXAwBOAMCs8v',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'ja-JP': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreed/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPsiArkYTl6YXAwBOAMCs8v',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/assassinscreed' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/assassinscreed/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/assassinscreed' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPsiArkYTl6YXAwBOAMCs8v',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/assassins_uk/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://discord.gg/AC' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'steep2':
        {
            name: 'Riders Republic',
            marketingSiteSpaceId: '8b97a550-590d-455c-a3c8-1fa678f0d685', // used in headers
            marketingSiteAppId: '0ad3ba89-7f59-4acd-8f37-30c43de651c1',
            appIds: [
                '8f6dd8a1-ad76-47f2-8b2e-f12333224a97', // PC
                'e10d5661-33b3-4021-b817-cc3abdab6372', // PS4
                '3bbc9471-067d-4e8b-869f-3558627ac19c', // XBOX One
                '1e9705a9-c7d2-4b6f-8242-ba7cd0b8e4b7', // PS5
                '58d00af4-087c-4a12-a835-6a5284c9ff68', // XBOX Series X|S
                '0727e9d3-4f24-4692-ba68-7caa80ed838b', // Stadia
            ],
            subStatuses: [
                SubStatusKey.Connectivity, // displayed 1st
                SubStatusKey.Authentication,
                SubStatusKey.Purchase,
            ],
            twitter: { 'default': 'ridersrepublic' },

            helpLinks: [
                { text: 'Customer Support', link: 'https://support.ubisoft.com/games/5764' },
            ],

            footer: {
                'emea': {
                    footerCopyTxt: {
                        'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. Riders Republic, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                    },
                    footerImages: {
                        'default': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/7eeef40649ec5966fc1a7bd06c3b17b6/RR_logo_WW_nav-footer_2.png',
                                    alt: 'brandFooter__brand__logo',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/570696d38c8dc35454313a631a1c2e58/pegi12Provisional.png',
                                    alt: 'brandFooter__rating__button',
                                    link: '',
                                },
                            ],
                        ],
                        'de-DE': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/80e3c2cbc6a2036cf83f7224259f29aa/RR_logo_WW_nav-footer_2.png',
                                    alt: 'brandFooter__brand__logo',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/544fdffc0e15b49f0824ccd0fb4d52b5/de-de.png',
                                    alt: 'brandFooter__rating__button',
                                    link: 'https://usk.de/',
                                },
                            ],
                        ],
                        'en-AU': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/80e3c2cbc6a2036cf83f7224259f29aa/RR_logo_WW_nav-footer_2.png',
                                    alt: 'brandFooter__brand__logo',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/6ef26b4c6aa6d205ff0b42668159707a/en-au.png',
                                    alt: 'brandFooter__rating__button',
                                    link: 'https://www.classification.gov.au/classification-ratings/what-do-ratings-mean',
                                },
                            ],
                        ],
                        'ru-RU': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/a418043b8f9d8d99c80acafb4e4408ce/RR_logo_WW_nav-footer_2.png',
                                    alt: 'brandFooter__brand__logo',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/09f6c5fd0d13a6b9f6dbeda2998b137d/ru-ru.png',
                                    alt: 'brandFooter__rating__button',
                                    link: '',
                                },

                            ],
                        ],
                        'ko-KR': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/50a7af244434c4fc92dd58fd95e04813/RR_logo_WW_nav-footer_2.png',
                                    alt: '',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/1f4f72ff7dd6f2e8c2deb0092b932ab9/ko-kr.png',
                                    alt: 'brandFooter__rating__button',
                                    link: '',
                                },
                            ],
                        ],
                        'ja-JP': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/8e59d39f3128d643ffd2d8144b6ffda6/RR_logo_WW_nav-footer_2.png',
                                    alt: '',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/bfdc655fcb9ee8972b7415e1b09c1c38/ja-jp.png',
                                    alt: 'brandFooter__rating__button',
                                    link: 'https://www.cero.gr.jp/',
                                },
                            ],
                        ],
                        'zh-CN': [],
                        'zh-TW': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/0027a8dfbc2c8d2c42e1b1cb017dec37/RR_logo_TCH_footer.png',
                                    alt: '',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/2W1hnEMOGIEnbnFkSHLmhu/3812cf510d1f29026ecc37b1fa10c027/zh-tw.png',
                                    alt: 'brandFooter__rating__button',
                                    link: 'http://www.gamerating.org.tw/',
                                },
                            ],
                        ],
                    },
                    footerSocial: {
                        'default': [],
                    },
                    footerLegalLinks: {
                        'default': [
                            { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                            { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                        ],
                        'de-DE': [
                            { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                            { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                        ],
                        'es-ES': [
                            { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                            { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                        ],
                        'fr-FR': [
                            { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                            { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                        ],
                        'it-IT': [
                            { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                            { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                        ],
                        'nl-NL': [
                            { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                            { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                        ],
                        'pl-PL': [
                            { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                            { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                        ],
                        'ru-RU': [
                            { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                            { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                            {
                                link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU',
                                text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ',
                            },
                        ],
                        'ko-KR': [
                            { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                            { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                        ],
                        'ja-JP': [
                            { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                            { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                            { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                        ],
                        'zh-CN': [],
                        'zh-TW': [],
                    },
                },
                'ncsa': {
                    footerCopyTxt: {
                        'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. Riders Republic, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                        'zh-CN': '©2006-2019 Ubisoft Entertainment. All Rights Reserved. Ubisoft, ubi.com, and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                    },
                    footerImages: {
                        'default': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/7eeef40649ec5966fc1a7bd06c3b17b6/RR_logo_WW_nav-footer_2.png',
                                    alt: '',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                    alt: 'brandFooter__rating__buttons',
                                    link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JWVHd2o40BUqwYKJh4yfT/d08bf640132c41565f495f9359d438bb/esrb-footer-rp.jpg',
                                    alt: 'brandFooter__rating__buttons',
                                    link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
                                },
                            ],
                        ],
                        'es-MX': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/9e07261990c31b8dca99a3fe6cb05881/RR_logo_WW_nav-footer_2.png',
                                    alt: '',
                                    link: '',
                                },
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                    alt: 'brandFooter__rating__buttons',
                                    link: 'http://www.esrb.org/ratings/ratings_guide.jsp',
                                },
                            ],
                        ],
                        'pt-BR': [
                            [
                                {
                                    img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7JslvUYD3tWc7g6UNjyIcg/bc676f95b5c2b2837b4735431bab131f/RR_logo_WW_nav-footer_2.png',
                                    alt: 'brandFooter__brand__logo',
                                    link: '',
                                },
                            ],
                        ],
                    },
                    footerSocial: {
                        'default': [],
                    },
                    footerLegalLinks: {
                        'default': [
                            { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                            { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                            { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'TERMS OF USE' },
                            {
                                link: 'https://legal.ubi.com/privacypolicy',
                                text: 'DO NOT SELL MY PERSONAL INFORMATION',
                            },
                        ],
                        'en-CA': [
                            { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                            { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                            { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                        ],
                        'fr-CA': [
                            { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                            { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                            { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                        ],
                        'es-MX': [
                            { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                            { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                            { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                        ],
                        'pt-BR': [
                            { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                            { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                            { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                        ],
                    },
                },
            },
            supportedLocales: [
                'fr-FR',
                'de-DE',
                'it-IT',
                'nl-NL',
                'pl-PL',
                'ru-RU',
                'es-ES',
                'en-US',
                'en-CA',
                'en-GB',
                'fr-CA',
                'es-MX',
                'pt-BR',
                'en-AU',
                'ko-KR',
                'ja-JP',
                'zh-CN',
                'zh-TW'],
        },
    'sppd': {
        name: 'South Park Phone Destroyer',
        marketingSiteSpaceId: '31378521-4e46-4c9d-b8e9-e6698cf15f62', // used in headers
        marketingSiteAppId: '42d9cccf-f8ae-42c0-8d82-ff73fab33708',
        appIds: [
            'f64d70a5-e962-445e-998c-9f4df6fb1156', // iOS
            'b5f1619b-8612-4966-a083-2fac253e2090', // Android
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
        ],
        twitter: { 'default': 'SouthParkPhone' },
        helpLinks: [
            {
                text: 'Customer Support',
                link: 'https://ubisoft-mobile.helpshift.com/hc/en/13-south-park-phone-destroyer/',
            },
            { text: 'Discord Channel', link: 'https://discord.gg/sppd ' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                showLogo: true,
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/7xx46JfhWAlQKOkmfOgom8/c455e2d1d38bb4487c33d45bb94415f2/pegi16-white.jpg',
                                alt: 'buttonMaster',
                                link: 'https://pegi.info',
                            },
                        ],
                    ],
                    'ru-RU': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3q4mycnCmraASGRLLOdCaC/872de4fc2c6a70197d88cfee6b19ddc5/rars16.png',
                                alt: 'buttonMaster',
                                link: '',
                            },
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/southparkphone' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/SouthParkPhoneDestroyer/',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/southparkphone/' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCsh8nwFp0JhAUbCy3YYB1RA',
                        },
                        {
                            icon: faComments,
                            title: 'Forums',
                            link: 'https://forums.ubisoft.com/forumdisplay.php/1568-South-Park-Phone-Destroyer?s=6c3c9e104da38b0860b7e2a57481d7df',
                        },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/UK%20Tax%20Strategy%20-%202019.pdf',
                            text: 'UK Tax strategy',
                        },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/slavery-and-human-trafficking-statement-2019-signed.pdf',
                            text: 'Modern Antislavery Act',
                        },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/UK%20Tax%20Strategy%20-%202019.pdf',
                            text: '英國稅收策略',
                        },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/slavery-and-human-trafficking-statement-2019-signed.pdf',
                            text: '現代反奴役法案',
                        },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFORMATION' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                showLogo: true,
                footerImages: {
                    'default': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                alt: 'ESRB Privacy Certified Logo Seal',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3DDboX6I9SZspBY28pYoa2/15cdb3fa7c713a068effafb8c2a80924/esrb_t.png',
                                alt: 'buttonMaster',
                                link: 'https://www.esrb.org/ratings-guide/',
                            },
                        ],
                    ],
                    'en-CA': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3TWaCi5CyuZBRpzsRP1iy/6384003e7b534b4962db554a21c696bb/esrb-privacy-footer.jpg',
                                alt: 'ESRB Privacy Certified Logo Seal',
                                link: 'http://www.esrb.org/confirm/ubisoft-confirmation.aspx',
                            },

                        ],
                    ],
                    'pt-BR': [
                        [
                            {
                                img: 'https://staticctf.akamaized.net/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/3DDboX6I9SZspBY28pYoa2/15cdb3fa7c713a068effafb8c2a80924/esrb_t.png',
                                alt: 'buttonMaster',
                                link: 'https://www.esrb.org/ratings-guide/',
                            },
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/southparkphone' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/SouthParkPhoneDestroyer/',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/southparkphone/' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCsh8nwFp0JhAUbCy3YYB1RA',
                        },
                        {
                            icon: faComments,
                            title: 'Forums',
                            link: 'https://forums.ubisoft.com/forumdisplay.php/1568-South-Park-Phone-Destroyer?s=6c3c9e104da38b0860b7e2a57481d7df',
                        },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/UK%20Tax%20Strategy%20-%202019.pdf',
                            text: 'UK Tax strategy',
                        },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/slavery-and-human-trafficking-statement-2019-signed.pdf',
                            text: 'Modern Antislavery Act',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                        { link: 'https://legal.ubi.com/InterestBasedAdvertising/pt-BR', text: 'Propagandas Interest' },
                    ],
                },
            },
        },

        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'tc2': {
        name: 'The Crew2',
        marketingSiteSpaceId: 'b3d0799d-431e-4b80-9154-d462e0b09187', // used in headers
        marketingSiteAppId: '96935ac1-844a-4310-b49d-ec8ad86294e1',
        appIds: [
            '41080f91-b0c8-4539-a5d9-965b14ef32bf', // PC
            'f4a49008-83ee-46f8-812d-79b5c971dce6', // PS4
            '5b5701f4-2b11-4942-a309-91e4f0218306', // XBOX One
            '7841f699-3c42-4727-9be3-d911114c55d9',  // Stadia
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
        ],
        twitter: { 'default': 'TheCrewGame' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/en-gb/help/game/the-crew-2' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. The Crew 2, Ubisoft and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                            pegi12_img,
                            nvidia_logo_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                            pegi12_img,
                            nvidia_logo_img,
                            usk12_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                            rars12_logo_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                            acbPG_logo_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                            gsrrPG12_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                            ubisoft_club_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            grac12_logo_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/TheCrewGame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/thecrewgame.uk/' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/thecrewgame/' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://thecrewgame.com/youtube' },
                        { icon: faComments, title: 'Forums', link: 'https://discussions.ubisoft.com/category/555/' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/UK%20Tax%20Strategy%20-%202019.pdf',
                            text: 'UK Tax strategy',
                        },
                        {
                            link: 'https://ubistatic2-a.akamaihd.net/gamesites/ubicom/slavery-and-human-trafficking-statement-2019-signed.pdf',
                            text: 'Modern Antislavery Act',
                        },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'UBISOFT PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFORMATION' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. The Crew 2, Ubisoft and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            ubisoft_store_img,
                            ubisoft_club_img,
                            ubisoft_blog_img,
                            ps4_logo_img,
                            xone_logo_img,
                            pc_dvd_logo_img('http://store.ubi.com/us/the-crew--2/598c6a3e0c8ee469268b456a.html'),
                            esrb_rating_teen_img,
                            esrb_privacy_cert_img,
                        ],
                    ],
                    'en-CA': [
                        [
                            ubisoft_white_img,
                            ubisoft_store_img,
                            ubisoft_club_img,
                            ubisoft_blog_img,
                            ps4_logo_img,
                            xone_logo_img,
                            pc_dvd_logo_img('http://store.ubi.com/us/the-crew--2/598c6a3e0c8ee469268b456a.html'),
                            esrb_rating_teen_img,
                            esrb_privacy_cert_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            _12_trails_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/TheCrewGame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/thecrewgame.usa/' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/thecrewgame/' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://thecrewgame.com/youtube' },
                        { icon: faComments, title: 'Forums', link: 'https://discussions.ubisoft.com/category/555/' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://www.ubisoft.com/en-us/privacy-policy.html', text: 'Privacy & Legal' },
                        {
                            link: 'https://legal.ubi.com/InterestBasedAdvertising/en-US?cache=22828524de97e0687d728e89b46a300c',
                            text: 'Interest-Based Ads',
                        },
                        {
                            link: 'https://legal.ubi.com/privacypolicy/en-US#ubi_mceLegalContentIndex_18',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                        { link: 'https://legal.ubi.com/InterestBasedAdvertising/pt-BR', text: 'Propagandas Interest' },
                    ],
                },
            },
        },

        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'fc6': {
        name: 'Far Cry 6',
        marketingSiteSpaceId: '3417c0bd-85f8-4647-b494-e717b99225e5', // used in headers
        marketingSiteAppId: '3b0ccc07-a877-499b-b4db-9188f64c294d',
        appIds: [
            'f70a2192-20da-4259-8acc-dd934076994b', // PS4
            '04659fba-f6d4-4cb3-8fb2-66cbed94b991', // PS5
            '4aedcedb-9e2d-4d9b-9094-231865a86f4c', // Xbox One
            '1fb21d47-95e5-4f39-87d7-b7a6ce74b06d', // Xbox Series X|S
            'd72bad75-18af-4dca-b5b7-069036d3bbd6', // PC
            '26a4bb76-5bb9-49e7-a7ce-c1bf9c770d85', // Stadia
            // Luna : ?
            // GeForce Now : ?
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'FarCrygame' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/help/game/far-cry-6' },
            { text: 'Gameplan', link: 'https://www.ubisoft.com/en-us/game/far-cry/far-cry-6/gameplan' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. Far Cry, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi18_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk18_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                            rars18_logo_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbR18_logo_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrR_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            grac18_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            ceroz_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/FarCryGamesUK' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_europe/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PL6A4LYU373asueSOprNPgi3cNF4YyfiXg',
                        },
                    ],
                    'de-DE': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/FarCryGamesUK' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_europe/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLgwdROUJzf2Hn1VbSDZ3Up5QOaPoYZno0',
                        },
                    ],
                    'es-ES': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry.es' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcry_es/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLcGfyH8QtajaE_ifUuK61uejxfxMZQVbX',
                        },
                    ],
                    'fr-FR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/farcryfr' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry.fr' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcry_fr/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLsOSLTtGun1BvCIfO9wJB7MaEOYJ0KQni',
                        },
                    ],
                    'it-IT': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry.it' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_it/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLw5Dt8Rh0GQe4oK_sOv43OWgWiqQREJ2k',
                        },
                    ],
                    'nl-NL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcryNL' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_us/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLY0uKVAB6iD91fhqLpwYo5E6SoSHA2Vvw',
                        },
                    ],
                    'pl-PL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/PolskaFarcry' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLj6-3JOkBqCDXOVytxnuScy2vG9NDRCw7',
                        },
                    ],
                    'ru-RU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faVk, title: 'Vk', link: 'https://vk.com/farcry' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_ru/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLoe4C0wU-T7x6wdgArFGq09H2UzBc8ONy',
                        },
                    ],
                    'en-AU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcryANZ' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_europe/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLK8BVoYA9OEOWM_wY6EycLhNLaUvxXWj0',
                        },
                    ],
                    'ko-KR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPspEk4vTAhCbbwgCTdsMyt',
                        },
                    ],
                    'ja-JP': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPspEk4vTAhCbbwgCTdsMyt',
                        },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLL2pPgJkVJ_UfnUpIMKqMZFn_F1Brb_Jd',
                        },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. Far Cry, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_ratingm_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            fc6_br_rating_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/FarCrygame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry.usa/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft/' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/c/UbisoftNA/search?query=far+cry',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/farcrygame_us/' },
                    ],
                    'en-CA': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftcanada?lang=en' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/farcry.usa/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft/' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCBMvc6jvuTxH6TNo9ThpYjg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftcanada' },
                    ],
                    'fr-CA': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftcanada' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Ubisoft.Canada' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoft/' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCBMvc6jvuTxH6TNo9ThpYjg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftcanada' },
                    ],
                    'es-MX': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UbisoftLatam' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/UbisoftLATAM/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/UbisoftLATAM' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftLatam' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftlatam/' },
                    ],
                    'pt-BR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UbisoftBrasil' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft.brasil/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoftbrasil' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCuBwNHXUJY7wg1qcJdq08Yg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftbrasil/' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },

        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'r6e': {
        name: 'Rainbow Six Extraction',
        marketingSiteSpaceId: '4ce12b70-a48c-4119-bcdb-16841486dfc0', // used in headers
        marketingSiteAppId: 'bd892e76-9522-434a-b09a-0c558aad1a9b',
        appIds: [
            'a0ce361c-c8ef-4671-a3ae-3cf7c05f5f95', // Cross platform
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'r6extraction' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/en-us/help/game/rainbow-six-extraction' },
            { text: 'Gameplan', link: 'https://www.ubisoft.com/en-us/game/rainbow-six/extraction/gameplan' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2020 Ubisoft Entertainment. All Rights Reserved. Far Cry, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi18_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk16_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                            rars18_logo_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbMA15_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrPG15_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            grac18_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            cerod_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/R6Extraction_UK' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/r6extraction_uk/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/R6ExtractionUK' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'de-DE': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/R6Extraction_DE' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/r6extraction_de/' },
                        {
                            icon: faFacebookF,
                            title: 'Facebook',
                            link: 'https://www.facebook.com/R6Extraction_DE-111146564487142',
                        },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'es-ES': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoft_spain' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_spain/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft.espana' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'fr-FR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/R6Extraction_FR' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/r6extraction_fr/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/R6ExtractionFR' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'it-IT': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftitalia' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftitalia/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoftitalia' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'nl-NL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftnl' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftnl/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/UbisoftNL' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'pl-PL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftpl' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftpl/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/UbisoftPL' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'ru-RU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftrussia' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_ru/' },
                        { icon: faVk, title: 'Vk', link: 'https://vk.com/ubisoft' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'en-AU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftanz' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftanz/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/UbisoftAustralia' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'ko-KR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/koreaubisoft' },
                        { icon: faInstagram, title: 'Instagram', link: '' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/UbisoftKR' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'ja-JP': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoft_japan' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_japan/' },
                        { icon: faFacebookF, title: 'Facebook', link: '' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { icon: faTwitter, title: 'Twitter', link: '' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_thi/' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Ubisoft.THI' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/R6Extraction' },
                        { icon: faReddit, title: 'Reddit', link: 'https://reddit.com/r/r6extraction' },
                        {
                            icon: faComments,
                            title: 'Forum',
                            link: 'https://discussions.ubisoft.com/category/607/rainbow-six',
                        },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2021 Ubisoft Entertainment. All Rights Reserved. Tom Clancy’s, Rainbow Six, the Soldier Icon, Ubisoft, and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            r6e_esrb_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            r6e_br_rating_16_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/r6extraction' },
                        {
                            icon: faInstagram,
                            title: 'Instagram',
                            link: 'https://www.instagram.com/r6extraction/?hl=en',
                        },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/R6Extraction' },
                    ],
                    'pt-BR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UbisoftBrasil' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft.brasil/' },
                        { icon: faTwitch, title: 'Twitch', link: 'https://www.twitch.tv/ubisoftbrasil' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCuBwNHXUJY7wg1qcJdq08Yg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftbrasil/' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },

        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'rc': {
        name: 'Roller Champions',
        marketingSiteSpaceId: '3417c0bd-85f8-4647-b494-e717b99225e5', // used in headers
        marketingSiteAppId: '3b0ccc07-a877-499b-b4db-9188f64c294d',
        appIds: [
            'f8bcbf86-c42e-4f21-97d7-2fc35b3ee87c', // PS4 + PS5
            'dc1efa29-ec34-4cc2-9ef8-236cfe025a0d', // Xbox One + Xbox Series X|S
            '34c5530a-84e9-4a0d-a557-85e9d7f9d004', // PC
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'RollerChampions' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/help/game/roller-champions' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2022 Ubisoft Entertainment. All Rights Reserved. The Roller Champions logo, Ubisoft, and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi7_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk6_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbG_logo_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrG_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            gracAll_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            ceroa_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitch, title: 'Twtch', link: 'https://rollerchampions.com/twitch' },
                        { icon: faTwitter, title: 'Twitter', link: 'https://rollerchampions.com/twitter' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://rollerchampions.com/facebook' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://rollerchampions.com/instagram' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPQ5HHgnl7yoOHwWD_Iitrj',
                        },
                        { icon: faTiktok, title: 'Tiktok', link: 'https://www.tiktok.com/@rollerchampions' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/rollerchampions' },
                    ],
                    'zh-CN': [],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2022 Ubisoft Entertainment. All Rights Reserved. The Roller Champions logo, Ubisoft, and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_rating_rp_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitch, title: 'Twtch', link: 'https://rollerchampions.com/twitch' },
                        { icon: faTwitter, title: 'Twitter', link: 'https://rollerchampions.com/twitter' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://rollerchampions.com/facebook' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://rollerchampions.com/instagram' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/playlist?list=PLBnrd5k2F2IPQ5HHgnl7yoOHwWD_Iitrj',
                        },
                        { icon: faTiktok, title: 'Tiktok', link: 'https://www.tiktok.com/@rollerchampions' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/rollerchampions' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'pop': {
        name: 'Prince of Persia',
        marketingSiteSpaceId: '82a0abc6-8c92-4baf-b5c6-34da27544887', // used in headers
        marketingSiteAppId: 'a66044b1-c2a5-44c4-a464-ca0c328526be',
        appIds: [
            'e1e04a50-7a85-46b7-afea-9c4f83b9de8d', // PC
            'b1a3c7f5-7dc2-446a-b555-c90527cc0d86', // Switch
            '1ccb499d-6d1f-452c-add2-09ac13c8563e', // PS4
            '22118087-f488-4060-808f-552a4406062a', // PS5
            '58dcaa5d-5fc7-4abd-8fa6-2f6deae9973a', // XBOX One
            '65ff10df-acc1-45de-8803-19b748347d10',  // XSeries
        ],
        subStatuses: [
            SubStatusKey.Connectivity, // displayed 1st
            SubStatusKey.Authentication, // not for Switch
        ],
        twitter: { 'default': 'princeofpersia' },
        helpLinks: [
            {
                text: 'Customer Support',
                link: 'https://www.ubisoft.com/help/prince-of-persia-the-lost-crown/all-topics',
            },
            { text: 'Discord', link: 'https://discord.gg/princeofpersia' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2023 Ubisoft Entertainment. All Rights Reserved. Based on Prince of Persia® created by Jordan Mechner. Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. Prince of Persia is a trademark of Waterwheel Licensing LLC in the US and/or other countries used under license.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi16_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk12_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbMA15_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrPG15_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            gracRP_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            cerorp_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoft_uk' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UC62IIuaPmV-KeuYmEaIZ0eQ',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftuk' },
                        { icon: faLinkedin, title: 'Linkedin', link: 'https://www.linkedin.com/company/ubisoft' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'de-DE': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftde' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftTV' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftde/' },
                        { icon: faTiktok, title: 'Tiktok', link: 'https://www.tiktok.com/@ubisoftde' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'es-ES': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoft_spain' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftSPA' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_spain' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'fr-FR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UbisoftFR' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft.france/' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftFR' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftfr/' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                        { icon: faLinkedin, title: 'Linkedin', link: 'https://www.linkedin.com/company/ubisoft' },
                    ],
                    'it-IT': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftitalia' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftITA' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftitalia/' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'pl-PL': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftpl' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/ubisoft' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftpl' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'en-AU': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/ubisoftanz' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/user/UbisoftANZ' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftanz' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                        { icon: faLinkedin, title: 'Linkedin', link: 'https://www.linkedin.com/company/ubisoft' },
                    ],
                    'zh-TW': [
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Ubisoft.TWN' },
                        { icon: faYoutube, title: 'Youtube', link: 'https://www.youtube.com/c/UbisoftSEA' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft.tw/' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'ja-JP': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/UBISOFT_JAPAN' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCfKxCaGCp6pNKmaz-MX5QlA',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoft_japan/' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'ko-KR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/koreaubisoft' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UC449Sbpw__odC-jrK3fpnGA',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/ubisoftkorea' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'zh-CN': [],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2023 Ubisoft Entertainment. All Rights Reserved. Based on Prince of Persia® created by Jordan Mechner. Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries. Prince of Persia is a trademark of Waterwheel Licensing LLC in the US and/or other countries used under license.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_rating_teen2_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            esrb_rating_teen2_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                        { icon: faLinkedin, title: 'Discord', link: 'https://www.linkedin.com/company/ubisoft' },
                    ],
                    'pt-BR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/Ubisoft' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCBMvc6jvuTxH6TNo9ThpYjg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://instagram.com/ubisoft' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                    'es-MX': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/Ubisoft' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/ubisoft/' },
                        { icon: faTwitch, title: 'Twtch', link: 'https://www.twitch.tv/ubisoft' },
                        {
                            icon: faYoutube,
                            title: 'Youtube',
                            link: 'https://www.youtube.com/channel/UCBMvc6jvuTxH6TNo9ThpYjg',
                        },
                        { icon: faInstagram, title: 'Instagram', link: 'https://instagram.com/ubisoft' },
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.gg/ubisoftofficial' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'ru-RU',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'skb': {
        name: 'Skull & Bones',
        marketingSiteSpaceId: '08e37554-182b-48aa-a5c0-610ef0ec9d5f', // used in headers
        marketingSiteAppId: '1c85f798-54a9-4407-9ffd-62aeac6aeb17',
        appIds: [
            '2dfa4bfd-b2c3-4993-8838-276d89bab144', // PC
            '5f5b7ede-1ef5-4a8c-9c09-dba12e2847b7', // PS5
            'e867aaaa-85dd-453a-8e87-7222fe0d524a', // XSeries
            '0691bc82-e673-48cb-9156-01a200e66cc1', // Luna
            '29b2c386-5bc3-4dbe-a6e1-b9c5a28fb4ca',  // Nvidia
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
        ],
        twitter: { 'default': 'skullnbonesgame' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/en-us/help/game/skull-and-bones' },
            { text: 'Bug reporter', link: 'https://www.ubisoft.com/en-us/game/skull-and-bones/bug-reporter' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2022 Ubisoft Entertainment. All Rights Reserved. Skull and Bones, Ubisoft, and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi18_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk16_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_rating_teen17_update_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbM_logo_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrPG18_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            grac18_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            cerod_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/skullnbonesgame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://facebook.com/skullandbonesgame' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/skullandbonesgame/' },
                        {
                            icon: faTwitch,
                            title: 'Twitch',
                            link: 'https://www.twitch.tv/directory/game/Skull%20&%20Bones/',
                        },
                    ],
                    'zh-CN': [],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2022 Ubisoft Entertainment. All Rights Reserved. Skull and Bones, Ubisoft, and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the US and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_rating_teen17_update_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            skb_br_rating_16_img,
                        ],
                    ],
                },
                footerSocial: {
                    'es-MX': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/skullnbonesgame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://facebook.com/skullandbonesgame' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/skullandbonesgame/' },
                        {
                            icon: faTwitch,
                            title: 'Twitch',
                            link: 'https://www.twitch.tv/directory/game/Skull%20&%20Bones/',
                        },
                    ],
                    'pt-BR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/skullnbonesgame' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://facebook.com/skullandbonesgame' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/skullandbonesgame/' },
                        {
                            icon: faTwitch,
                            title: 'Twitch',
                            link: 'https://www.twitch.tv/directory/game/Skull%20&%20Bones/',
                        },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW'],
    },
    'xd': {
        name: 'XDefiant',
        marketingSiteSpaceId: 'ed8600fa-a5d9-48a2-8ab7-d9f41c0c2029', // used in headers
        marketingSiteAppId: 'f35adcb5-1911-440c-b1c9-48fdc1701c68',
        appIds: [
            '4bc245f2-b998-4574-9574-6ab93ec9e44c', // PC
            'f7c5cbfd-afdd-46f6-80fa-4855424ff928', // PS5
            '99843ca4-b165-4781-8936-93de3b2e9629', // XSeries
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'PlayXDefiant' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/help/game/tom-clancys-xdefiant' },
            { text: 'Discord', link: 'https://discord.gg/XDefiant' },
        ],
        footer: {
            'emea': {
                footerCopyTxt: {
                    'default': '© 2024 Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            pegi16_2_img,
                        ],
                    ],
                    'de-DE': [
                        [
                            ubisoft_white_img,
                            usk16_logo_img,
                        ],
                    ],
                    'ru-RU': [
                        [
                            ubisoft_white_img,
                            rars18_logo_img,
                        ],
                    ],
                    'en-AU': [
                        [
                            ubisoft_white_img,
                            acbCTC_logo_img,
                        ],
                    ],
                    'zh-TW': [
                        [
                            ubisoft_white_img,
                            gsrrPG15_logo_img,
                        ],
                    ],
                    'zh-CN': [
                        [
                            ubisoft_white_img,
                        ],
                    ],
                    'ko-KR': [
                        [
                            ubisoft_white_img,
                            grac15_logo_img,
                        ],
                    ],
                    'ja-JP': [
                        [
                            ubisoft_white_img,
                            ceroc_img,
                        ],
                    ],
                },
                footerSocial: {
                    'default': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/playxdefiant' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Playxdefiant/' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/playxdefiant/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                    'zh-CN': [],
                    'ru-RU': [
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Playxdefiant/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                    'de-DE': [
                        { link: 'https://legal.ubi.com/privacypolicy/de-DE', text: 'DATENSCHUTZ' },
                        { link: 'https://legal.ubi.com/termsofuse/de-DE', text: 'NUTZUNGSBEDINGUNGEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/de-DE', text: 'IMPRESSUM' },
                    ],
                    'es-ES': [
                        { link: 'https://legal.ubi.com/privacypolicy/es-ES', text: 'POLÍTICA DE PRIVACIDAD' },
                        { link: 'https://legal.ubi.com/termsofuse/es-ES', text: 'TÉRMINOS DE USO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/es-ES', text: 'INFORMACION LEGAL' },
                    ],
                    'fr-FR': [
                        { link: 'https://legal.ubi.com/privacypolicy/fr-FR', text: 'CONFIDENTIALITÉ' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-FR', text: 'CONDITIONS D\'UTILISATION' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/fr-FR', text: 'MENTIONS LÉGALES' },
                    ],
                    'it-IT': [
                        { link: 'https://legal.ubi.com/privacypolicy/it-IT', text: 'INFORMATIVA SULLA PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/it-IT', text: 'CONDIZIONI DI UTILIZZO' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/it-IT', text: 'INFORMAZIONI LEGALI' },
                    ],
                    'nl-NL': [
                        { link: 'https://legal.ubi.com/privacypolicy/nl-NL', text: 'PRIVACYBELEID' },
                        { link: 'https://legal.ubi.com/termsofuse/nl-NL', text: 'GEBRUIKSVOORWAARDEN' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/nl-NL', text: 'WETTELIJKE INFO' },
                    ],
                    'pl-PL': [
                        { link: 'https://legal.ubi.com/privacypolicy/pl-PL', text: 'POLITYKA PRYWATNOŚCI' },
                        { link: 'https://legal.ubi.com/termsofuse/pl-PL', text: 'WARUNKI KORZYSTANIA' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/pl-PL', text: 'INFORMACJE PRAWNE' },
                    ],
                    'ru-RU': [
                        { link: 'https://legal.ubi.com/privacypolicy/ru-RU', text: 'Политика конфиденциальности' },
                        { link: 'https://legal.ubi.com/termsofuse/ru-RU', text: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ru-RU', text: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ' },
                    ],
                    'ko-KR': [
                        { link: 'https://legal.ubi.com/privacypolicy/ko-kr', text: '개인정보처리방침' },
                        { link: 'https://legal.ubi.com/termsofuse/ko-Kr', text: '서비스 이용 약관' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ko-Kr', text: '법적 고지' },
                    ],
                    'ja-JP': [
                        { link: 'https://legal.ubi.com/privacypolicy/ja-JP', text: 'プライバシーポリシー' },
                        { link: 'https://legal.ubi.com/termsofuse/ja-JP', text: '利用規約' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/ja-jp', text: 'リーガル情報' },
                    ],
                    'zh-CN': [],
                    'zh-TW': [
                        { link: 'https://legal.ubi.com/privacypolicy/zh-TW', text: '隱私權政策' },
                        { link: 'https://legal.ubi.com/termsofuse/zh-TW', text: '使用條款' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/zh-TW', text: '法律資訊' },
                    ],
                    'en-AU': [
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY POLICY' },
                        { link: 'https://legal.ubi.com/termsofuse', text: 'TERMS OF USE' },
                        { link: 'https://legal.ubi.com/LegalInfoUbisoftEMEA/', text: 'LEGAL INFO' },
                    ],
                },
            },
            'ncsa': {
                footerCopyTxt: {
                    'default': '© 2024 Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries.',
                },
                footerImages: {
                    'default': [
                        [
                            ubisoft_white_img,
                            esrb_privacy_cert_img,
                            esrb_rating_extended_img,
                        ],
                    ],
                    'pt-BR': [
                        [
                            ubisoft_white_img,
                            esrb_rating_extended_img,
                        ],
                    ],
                    'es-MX': [
                        [
                            ubisoft_white_img,
                            esrb_rating_extended_img,
                        ],
                    ],
                },
                footerSocial: {
                    'en-US': [
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                    'es-MX': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/playxdefiant' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Playxdefiant/' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/playxdefiant/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                    'pt-BR': [
                        { icon: faTwitter, title: 'Twitter', link: 'https://twitter.com/playxdefiant' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Playxdefiant/' },
                        { icon: faInstagram, title: 'Instagram', link: 'https://www.instagram.com/playxdefiant/' },
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                    'en-CA': [
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                    'fr-CA': [
                        { icon: faDiscord, title: 'Discord', link: 'http://www.discord.gg/XDefiant' },
                    ],
                },
                footerLegalLinks: {
                    'default': [
                        { link: 'https://www.ubisoft.com/en-us/contact-us.html', text: 'Contact Us' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Privacy' },
                        { link: 'https://legal.ubi.com/termsofuse/en-US', text: 'Terms of use' },
                        {
                            link: 'https://legal.ubi.com/DoNotSellMyPersonalInformation/en-US',
                            text: 'DO NOT SELL MY PERSONAL INFORMATION',
                        },
                    ],
                    'en-CA': [
                        { link: 'https://www.ubisoft.com/en-ca/contact-us.html', text: 'CONTACT US' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'PRIVACY' },
                        { link: 'https://legal.ubi.com/termsofuse/en-CA', text: 'UBISOFT TERMS OF USE' },
                    ],
                    'fr-CA': [
                        { link: 'https://www.ubisoft.com/fr-ca/contact-us.html', text: 'NOUS CONTACTER' },
                        { link: 'https://legal.ubi.com/privacypolicy', text: 'Charte de confidentialité' },
                        { link: 'https://legal.ubi.com/termsofuse/fr-CA', text: 'Termes' },
                    ],
                    'es-MX': [
                        { link: 'https://www.ubisoft.com/es-mx/contact-us.html', text: 'Contacto' },
                        { link: 'https://legal.ubi.com/privacypolicy/es-INTL', text: 'Privacidad' },
                        { link: 'https://legal.ubi.com/termsofuse/es-MX', text: 'Condiciones' },
                    ],
                    'pt-BR': [
                        { link: 'https://www.ubisoft.com/pt-br/contact-us.html', text: 'Contatos' },
                        { link: 'https://legal.ubi.com/privacypolicy/pt-BR', text: 'Privacidade' },
                        { link: 'https://legal.ubi.com/termsofuse/pt-BR', text: 'Termos' },
                    ],
                },
            },
        },
        supportedLocales: [
            'fr-FR',
            'de-DE',
            'it-IT',
            'nl-NL',
            'pl-PL',
            'es-ES',
            'en-US',
            'en-CA',
            'en-GB',
            'fr-CA',
            'es-MX',
            'pt-BR',
            'en-AU',
            'ko-KR',
            'ja-JP',
            'zh-CN',
            'zh-TW',
            'ru-RU'],
    },
    'fh': {
        name: 'For Honor',
        marketingSiteSpaceId: '6101ab04-17b4-4bdc-bfac-88074ef8394f', // used in headers
        marketingSiteAppId: 'fb837d26-0845-4eb3-8ea6-554fbd577acd',
        appIds: [
            '3b27ede8-3ff9-435d-a264-e2de2ccbb2ce', // PC
            '0aa18dfd-204d-42b4-a631-2d5952c21999', // PS4
            '63637663-c6f6-4eb2-99d1-083196b01d68', // XBOXONE
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'forhonorgame' },
        helpLinks: [],
        footer: {},
        supportedLocales: [
            'zh-CN',
            'zh-TW',
            'cs-CZ',
            'nl-NL',
            'en-GB',
            'en-US',
            'fr-FR',
            'fr-CA',
            'de-DE',
            'it-IT',
            'ja-JP',
            'ko-KR',
            'pl-PL',
            'pt-BR',
            'ru-RU',
            'es-ES',
            'es-MX',
            'tr-TR',
        ],
    },
    'r6s': {
        name: 'Rainbow Six Siege',
        marketingSiteSpaceId: 'aac52d2d-47f2-4580-812d-5d6edff9cf2e', // used in headers
        marketingSiteAppId: 'f612511e-58a2-4e9a-831f-61838b1950bb',
        appIds: [

            'e3d5ea9e-50bd-43b7-88bf-39794f4e3d40',
            'fb4cc4c9-2063-461d-a1e8-84a7d36525fc',
            '4008612d-3baf-49e4-957a-33066726a7bc',
            '6e3c99c9-6c3f-43f4-b4f6-f1a3143f2764',
            '76f580d5-7f50-47cc-bbc1-152d000bfe59',
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'rainbow6game' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://www.ubisoft.com/help/game/rainbow-six-siege' },
            { text: 'R6Fix', link: 'https://r6fix.ubi.com/projects/RAINBOW6-SIEGE-LIVE' },
        ],
        footer: {},
        supportedLocales: [
            'zh-CN',
            'zh-TW',
            'cs-CZ',
            'nl-NL',
            'en-GB',
            'en-US',
            'fr-FR',
            'fr-CA',
            'de-DE',
            'it-IT',
            'ja-JP',
            'ko-KR',
            'pl-PL',
            'pt-BR',
            'ru-RU',
            'es-ES',
            'es-MX',
            'tr-TR',
        ],
    },
    'r6mobile': {
        name: 'Rainbow Six Mobile',
        marketingSiteSpaceId: '0f15d8fa-ef5a-4f69-b424-1c07ebdb0e14', // used in headers
        marketingSiteAppId: '67495989-4cd4-4fe6-bad5-b25af409bc64',
        appIds: [
            'bfd9dc39-90b5-4462-987f-582697a58cf6',
            'ad6d9e79-f979-48b9-90ef-a5d8757bf02f',
        ],
        subStatuses: [
            SubStatusKey.Connectivity,
            SubStatusKey.Authentication,
            SubStatusKey.Purchase,
            SubStatusKey.Matchmaking,
        ],
        twitter: { 'default': 'rainbow6mobile' },
        helpLinks: [
            { text: 'Customer Support', link: 'https://ubisoft-mobile.helpshift.com/hc/app/45-rainbow-six-mobile/' },
            { text: 'Bug Reporter', link: 'https://www.ubisoft.com/en-us/game/rainbow-six/mobile/bug-reporter' },
        ],
        footer: {
            'ncsa': {
                footerSocial: {
                    'pt-BR': [
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.com/invite/qNCHjq5jRu', text: 'Discord' },
                        { icon: faDiscord, title: 'LATAM Discord', link: 'https://discord.gg/yEupPbwQsg', text: 'LATAM Discord' },
                        { icon: faTwitter, title: 'Twitter', link: 'https://x.com/rainbow6mobile/', text: 'rainbow6mobile' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Rainbow6Mobile/', text: 'Rainbow6Mobile' },
                        { icon: faReddit, title: 'Reddit', link: 'https://www.reddit.com/r/Rainbow6Mobile/', text: '/r/Rainbow6Mobile' },
                        { icon: faGlobe, title: 'Website', link: 'https://rainbowsixmobile.com', text: 'rainbowsixmobile.com' },
                    ],
                    'es-MX': [
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.com/invite/qNCHjq5jRu', text: 'Discord' },
                        { icon: faDiscord, title: 'LATAM Discord', link: 'https://discord.gg/yEupPbwQsg', text: 'LATAM Discord' },
                        { icon: faTwitter, title: 'Twitter', link: 'https://x.com/rainbow6mobile/', text: 'rainbow6mobile' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Rainbow6Mobile/', text: 'Rainbow6Mobile' },
                        { icon: faReddit, title: 'Reddit', link: 'https://www.reddit.com/r/Rainbow6Mobile/', text: '/r/Rainbow6Mobile' },
                        { icon: faGlobe, title: 'Website', link: 'https://rainbowsixmobile.com', text: 'rainbowsixmobile.com' },
                    ],
                },
                footerCopyTxt: {},
                footerImages: {},
                footerLegalLinks: {},
            },
            'default': {
                footerSocial: {
                    'default': [
                        { icon: faDiscord, title: 'Discord', link: 'https://discord.com/invite/qNCHjq5jRu', text: 'Discord' },
                        { icon: faTwitter, title: 'Twitter', link: 'https://x.com/rainbow6mobile/', text: 'rainbow6mobile' },
                        { icon: faFacebookF, title: 'Facebook', link: 'https://www.facebook.com/Rainbow6Mobile/', text: 'Rainbow6Mobile' },
                        { icon: faReddit, title: 'Reddit', link: 'https://www.reddit.com/r/Rainbow6Mobile/', text: '/r/Rainbow6Mobile' },
                        { icon: faGlobe, title: 'Website', link: 'https://rainbowsixmobile.com', text: 'rainbowsixmobile.com' },
                    ],
                },
                footerCopyTxt: {},
                footerImages: {},
                footerLegalLinks: {},
            },
        },
        supportedLocales: [
            'zh-CN',
            'zh-TW',
            'cs-CZ',
            'nl-NL',
            'en-GB',
            'en-US',
            'fr-FR',
            'fr-CA',
            'de-DE',
            'it-IT',
            'ja-JP',
            'ko-KR',
            'pl-PL',
            'pt-BR',
            'ru-RU',
            'es-ES',
            'es-MX',
            'tr-TR',
        ],
    },
}

export default statusPageData